module.exports = __webpack_public_path__ + "img/logo.8e658de7.png";